import React from "react"
import { useParams, useHistory } from "react-router-dom"
import { API } from "aws-amplify"
import { useRecoilState } from "recoil"
import { useSnackbar } from "notistack"
import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import CircularProgress from "@material-ui/core/CircularProgress"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import StepContent from "@material-ui/core/StepContent"
import Typography from "@material-ui/core/Typography"

import ConfirmEmailForm from "../../forms/ConfirmEmail"
import UserInfoForm from "../../forms/UserInfo"
import { getInvite as GetInvite } from "../../graphqlCustom/queries"
import onboardingProgress from "../../store/onboardingProgress"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}))

function getSteps(progress) {
  return [
    {
      form: <UserInfoForm />,
      title: "Your Information",
    },
    {
      form: <ConfirmEmailForm />,
      title: "Confirm Your Email",
    },
  ]
}

export default function User() {
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const [progress, setProgress] = useRecoilState(onboardingProgress)
  const steps = getSteps(progress)
  const [isAuthenticating, setIsAuthenticating] = React.useState(true)
  const [invite, setInvite] = React.useState({})
  const history = useHistory()
  const { token } = useParams()

  // Beta required for now
  React.useEffect(() => {
    async function fetchInvite(id) {
      try {
        const response = await API.graphql({
          authMode: "AWS_IAM",
          query: GetInvite,
          variables: {
            id,
          },
        })
        if (response.data.getInvite == null) {
          throw new Error("No invite exists")
        }
        const { getInvite: inviteDb } = response.data
        setInvite(inviteDb)
        setProgress({
          ...progress,
          inviteToken: id,
          invite: inviteDb,
        })
        setIsAuthenticating(false)
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar(`Invite has expired or does not exist`, {
          variant: "error",
        })
        return history.push("/signup")
      }
    }

    if (token) {
      fetchInvite(token)
    } else {
      setIsAuthenticating(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!isAuthenticating ? (
        <div className={classes.root}>
          <Typography variant="h2">Join {invite.association.name}</Typography>
          <Stepper activeStep={progress.activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={step.title}>
                <StepLabel>{step.title}</StepLabel>
                <StepContent>
                  <Box pt={4}>{step.form}</Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </div>
      ) : (
        <CircularProgress />
      )}
    </>
  )
}
